<script setup lang="ts">
import { onMounted, onUnmounted, useTemplateRef } from 'vue';

import ConfirmStepNewAirRoadSection from '@/components/sections/ConfirmStepNewAirRoadSection.vue';
import { useNewAirRoadViewStore } from '@/stores/useNewAirRoadViewStore';
import * as airRoadConstants from '@/constants/airRoad';

const newAirRoadViewStore = useNewAirRoadViewStore();

const confirmFormRef = useTemplateRef<HTMLFormElement>('confirmForm');

onMounted(function () {
  newAirRoadViewStore.setConfirmFormElement(confirmFormRef.value);
});

onUnmounted(function () {
  newAirRoadViewStore.setConfirmFormElement(null);
});
</script>

<template>
  <v-form
    ref="confirmForm"
    v-model="
      newAirRoadViewStore.bookingStepValidationState[
        airRoadConstants.bookingStepValues.CONFIRM
      ]
    "
    :class="$style.confirmNewAirRoadStepForm"
    data-testid="confirmNewAirRoadStepForm"
    validate-on="lazy"
  >
    <input type="submit" class="hidden" disabled />
    <ConfirmStepNewAirRoadSection
      v-model="newAirRoadViewStore.bookingState"
      :air-road-booking-job="newAirRoadViewStore.data.airRoadBookingJob"
    />
  </v-form>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.confirmNewAirRoadStepForm {
}
</style>
